import { Box, Skeleton } from "@mui/material";

interface QrCodeSkeletonProps {
  isMobile?: boolean;
}

const QrCodeSkeleton = ({ isMobile = false }: QrCodeSkeletonProps) => (
  <Box
    sx={{
      width: isMobile ? "100%" : "200px",
      minHeight: isMobile ? "600px" : "360px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",
      padding: "16px",
      backgroundColor: "#1E4164",
      borderRadius: "16px",
    }}
  >
    <Skeleton
      variant="circular"
      width={40}
      height={40}
      sx={{ bgcolor: "rgba(255,255,255,0.1)" }}
    />
    <Skeleton
      variant="text"
      width={100}
      height={20}
      sx={{ bgcolor: "rgba(255,255,255,0.1)" }}
    />
    <Skeleton
      variant="rounded"
      width={130}
      height={130}
      sx={{ bgcolor: "rgba(255,255,255,0.9)", borderRadius: "8px" }}
    />
    <Skeleton
      variant="text"
      width={70}
      height={16}
      sx={{ bgcolor: "rgba(255,255,255,0.1)" }}
    />
    <Skeleton
      variant="text"
      width={90}
      height={14}
      sx={{ bgcolor: "rgba(255,255,255,0.1)" }}
    />
  </Box>
);

export default QrCodeSkeleton;
